module.exports = __webpack_public_path__ + "static/media/b2_p16_clickable_b.f396df33.mp3";